/** @jsxImportSource @emotion/react */
import { forwardRef, useMemo } from "react";
import styled from "@emotion/styled";
import { PercentageButton } from "../../ButterComponents/PercentageButton/PercentageButton";

export enum BalancePercentageOptionsEnum {
  "25%" = "0.25",
  "50%" = "0.5",
  "75%" = "0.75",
  "Max" = "Max",
}

export type BalancePercentageOptionsKeys = keyof typeof BalancePercentageOptionsEnum;

interface BalancePercentagesProps {
  handlePercentageClick: (percent: BalancePercentageOptionsEnum) => void;
  balancePercentageActive: BalancePercentageOptionsEnum | undefined;
}
export const BalancePercentages = forwardRef<HTMLDivElement, BalancePercentagesProps>(
  ({ handlePercentageClick, balancePercentageActive }, ref) => {
    const balancePercentageButtons = useMemo(() => {
      const keys = Object.keys(BalancePercentageOptionsEnum) as Array<BalancePercentageOptionsKeys>;
      return keys.map(key => (
        <PercentageButton
          key={key.toString()}
          onClick={() => handlePercentageClick(BalancePercentageOptionsEnum[key])}
          isActive={balancePercentageActive === BalancePercentageOptionsEnum[key]}
        >
          {key}
        </PercentageButton>
      ));
    }, [balancePercentageActive, handlePercentageClick]);

    return (
      <BalancePercentagesContainer ref={ref}>
        {balancePercentageButtons}
      </BalancePercentagesContainer>
    );
  }
);

const BalancePercentagesContainer = styled.div`
  display: flex;
  padding: 2px 0 14px 0;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;
